import React from 'react'
import { Views } from '../../views'

const Contact = () => {
    const { Contact } = Views
    return (
        <Contact />
    )
}

export default Contact